export default __webpack_public_path__ + "static/Thudie-2f6077249c09bb4967e03cd32d515c23.svg";